import { useQuery } from 'react-query';
import { message } from 'antd';
import request from '../../../../../helpers/request';

export const shutdownAlisaAudioKey = (shutdownId) => [
  'shutdownAlisaAudio',
  shutdownId,
];

const shutdownAlisaAudioQuery = async ({ queryKey }) => {
  const [_, shutdownId] = queryKey;

  return await request.get(
    `/Alert/audio/${shutdownId}`,
    {},
    `При загрузке аудио произошла ошибка`
  );
};

export const useShutdownAlisaAudio = (shutdownId, options = {}) =>
  useQuery(shutdownAlisaAudioKey(shutdownId), shutdownAlisaAudioQuery, {
    select: (data) => {
      if (data) {
        try {
          const buf = Buffer.from(data, 'base64');
          const audioData = buf.buffer.slice(
            buf.byteOffset,
            buf.byteOffset + buf.byteLength
          );

          return audioData;
        } catch (err) {
          console.error('err', err);
          message.error('Не удалось декодировать аудио');
        }
      }
    },
    ...options,
  });
